import { useEffect, useRef } from "react";

const GLYPHS = "アイウエオカキクケコサシスセソ0123456789ABCDEF<>/{}=+*";
const glyph = () => GLYPHS[Math.floor(Math.random() * GLYPHS.length)];

const fadeColor = (intense, dark) => {
  if (intense) return "rgba(0,0,0,0.055)";
  return dark ? "rgba(10,10,11,0.12)" : "rgba(245,245,247,0.18)";
};

const paintIntense = (ctx, x, y, size) => {
  ctx.fillStyle = "#0e5a7a";
  ctx.fillText(glyph(), x, (y - 1) * size);
  ctx.shadowColor = "#3DDBE8";
  ctx.shadowBlur = 8;
  ctx.fillStyle = Math.random() > 0.92 ? "#ffd59a" : "#3DDBE8";
  ctx.fillText(glyph(), x, y * size);
  ctx.shadowBlur = 0;
};

const paintFrame = (ctx, c, drops, { intense, size }) => {
  const dark = document.documentElement.classList.contains("dark");
  ctx.fillStyle = fadeColor(intense, dark);
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.font = `${intense ? "bold " : ""}${size - 4}px JetBrains Mono, monospace`;
  drops.forEach((y, i) => {
    if (!intense && i % 3) return;
    if (intense) paintIntense(ctx, i * size, y, size);
    else {
      ctx.fillStyle = dark ? "#3DDBE8" : "#0891b2";
      ctx.fillText(glyph(), i * size, y * size);
    }
    drops[i] = y * size > c.height && Math.random() > 0.975 ? 0 : y + 1;
  });
};

export const DigitalRain = ({ intense = false }) => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    const opts = { intense, size: intense ? 18 : 16 };
    const interval = intense ? 55 : 70;
    let drops = [];
    let raf;
    let last = 0;
    const resize = () => {
      c.width = window.innerWidth;
      c.height = window.innerHeight;
      drops = Array.from({ length: Math.ceil(c.width / opts.size) }, () => Math.random() * -60);
    };
    resize();
    window.addEventListener("resize", resize);
    const draw = (t) => {
      raf = requestAnimationFrame(draw);
      if (t - last < interval) return;
      last = t;
      paintFrame(ctx, c, drops, opts);
    };
    raf = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [intense]);
  if (intense) {
    return (
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0 bg-black" data-testid="landing-matrix-rain">
        <canvas ref={ref} className="absolute inset-0 opacity-90" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0.75)_100%)]" />
      </div>
    );
  }
  return <canvas ref={ref} aria-hidden className="pointer-events-none fixed inset-0 z-0 opacity-[0.07] dark:opacity-[0.09]" />;
};
